
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
function AddStaff() {
    const [rowsData, setRowsData] = useState([]);
    const [sortConfig, setSortConfig] = useState({
        key: "name",
        direction: "ascending",
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(3);
    const [searchQuery, setSearchQuery] = useState(""); // New state for search query

    useEffect(() => {
        const fetchData = async () => {
            const data = [
                {
                    "Sl_No": "4",
                    "Status": "D",

                    "Name": "chennai",
                    "Account_No": "",
                    "Code": "AS3761",
                    "STB_No": "76544534563",
                    "D_No": "3",
                    "Flat_Name": "dfhg",
                    "Street": "1st MAIN RD, B.NAGAR",
                    "Mobile_No": "5464576587",
                    "Pay_Status": "free",
                    "Plan_Amount": "0",
                    "Paid_Amount": "0",

                    "Staff_Code": "TCCL CLASSIC SD",
                    "Network": "25-Oct-19",

                    "Collection_Staff": "UGF",

                },

            ];
            setRowsData(data);
        };

        fetchData();
    }, []);

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }

        const sortedData = [...rowsData].sort((a, b) => {
            if (a[key] < b[key]) {
                return direction === "ascending" ? -1 : 1;
            }
            if (a[key] > b[key]) {
                return direction === "ascending" ? 1 : -1;
            }
            return 0;
        });

        setRowsData(sortedData);
        setSortConfig({ key, direction });
    };

    const downloadCSV = () => {
        const headers = [
            "Sl_No", "Status", "Edit", "Select", "Pay", "Name", "Account_No", "Code", "STB_No",
            "D_No", "Flat_Name", "Street", "Mobile_No", "Pay_Status", "Plan_Amount", "Paid_Amount",
            "Paid_Date", "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
            "Staff_Code", "Network", "Paid_Time", "Packages", "History", "Location", "Collection_Staff", "Delete"
        ];
        const csvRows = [];
        csvRows.push(headers.join(","));
        rowsData.forEach(row => {
            csvRows.push([row.Sl_No, row.Status, row.Edit, row.Select, row.Pay, row.Name, row.Account_No,
            row.Code, row.STB_No, row.D_No, row.Flat_Name, row.Street, row.Mobile_No,
            row.Pay_Status, row.Plan_Amount, row.Paid_Amount, row.Paid_Date, row.Balance_Amount,
            row.Discount_Amount, row.Advance_Amount, row.Pending_Amount, row.Staff_Code, row.Network,
            row.Paid_Time, row.Packages, row.History, row.Location, row.Collection_Staff].join(","));
        });

        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rowsData.slice(indexOfFirstRow, indexOfLastRow);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(rowsData.length / rowsPerPage);

    // Filter rows based on search query across all columns
    const filteredRows = currentRows.filter((row) =>
        Object.values(row).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase()) // Ensure value is converted to string
        )
    );

    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4">ADD STAFF DETAILS</div>
                </div>
                <hr />
                <div className=" mt-3 mb-2 p-2">

                    <h5 className="text-center">Modify Customer STB</h5>

                   
                        <form action="/allCustomer" method="get">
                            <div className="row mx-3 d-flex justify-content-center">


                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="collectionstaff" className="text-center valuesDec text-navy">Collection Staff Name</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="collectionstaff" id="collectionstaff" placeholder="Collection Staff Name..." />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="date" className="text-center valuesDec text-navy">Date Of Birth</label>
                                        <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="mobilenumber" className="text-center valuesDec text-navy">Mobile Number</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="mobilenumber" id="mobilenumber" placeholder="Mobile Number..." />
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="icentive" className="text-center valuesDec text-navy">Address</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="icentive" id="icentive" placeholder="Incentive amount..." />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="password" className="text-center valuesDec text-navy">Password</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="password" id="password" placeholder="Password..." />
                                    </div>
                                </div>
                              
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="staffcode" className="text-center valuesDec text-navy">Staff Code</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="staffcode" id="staffcode" placeholder="Staff code..." />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="role" className="text-center valuesDec text-navy">Role</label>
                                        <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="role" name="role">
                                            <option value="all">All</option>
                                        </select>
                                    </div>
                                </div>
                              
                                <div className="col-lg-3 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2">
                            
                                        <input type="submit" className="btn border-0 bg-gradient-info filterBtn rounded text-light h-75 pb-3  w-100" value="Submit" />
                                  
                                </div>

                            </div>

                        </form>
                    
                </div>
              
            
              
            </div>
        </div>
    );
}

export default AddStaff;
